import { Box, Table, TableRow, TableHead, Grid } from '@mui/material'
import ExpensesTableHeadCell from './ExpensesTableHeadCell'

const ExpensesTableHead = ({
  sortConfig,
  onExpensesTableHeadSort,
  isGlobalView,
}) => {
  return (
    <Grid sx={{ paddingRight: '4%', paddingLeft: '5%' }}>
      <Box component={Table} size="small" sx={{ marginLeft: 'auto' }}>
        <TableHead>
          <TableRow>
            {isGlobalView ? (
              <>
                <ExpensesTableHeadCell
                  cellName="Libellée"
                  textAlign="left"
                  paddingRight="25px"
                  paddingLeft="0%"
                />
                <ExpensesTableHeadCell
                  cellName="Charges"
                  width="20%"
                  textAlign="right"
                  paddingRight="2%"
                />
                <ExpensesTableHeadCell
                  cellName="Produits"
                  width="20%"
                  textAlign="right"
                  paddingRight="1%"
                />
              </>
            ) : (
              <>
                <ExpensesTableHeadCell
                  cellName="date"
                  width="90px"
                  textAlign="left"
                  sortConfig={sortConfig}
                  onExpensesTableHeadSort={onExpensesTableHeadSort}
                />
                <ExpensesTableHeadCell
                  cellName="libelle"
                  sortConfig={sortConfig}
                  onExpensesTableHeadSort={onExpensesTableHeadSort}
                />
                <ExpensesTableHeadCell
                  cellName="montant"
                  width="9%"
                  textAlign="right"
                  sortConfig={sortConfig}
                  onExpensesTableHeadSort={onExpensesTableHeadSort}
                />
                <ExpensesTableHeadCell
                  cellName="tva"
                  width="9%"
                  textAlign="right"
                  sortConfig={sortConfig}
                  onExpensesTableHeadSort={onExpensesTableHeadSort}
                />
                <ExpensesTableHeadCell
                  cellName="recuperable"
                  width="9%"
                  textAlign="right"
                  sortConfig={sortConfig}
                  onExpensesTableHeadSort={onExpensesTableHeadSort}
                />
                <ExpensesTableHeadCell
                  cellName="deductible"
                  width="9%"
                  textAlign="right"
                  sortConfig={sortConfig}
                  onExpensesTableHeadSort={onExpensesTableHeadSort}
                />
              </>
            )}
          </TableRow>
        </TableHead>
      </Box>
    </Grid>
  )
}

export default ExpensesTableHead
